import React from 'react'

export const SingleBarBarchart = ({ size, barHeight, barFill }) => {
  return (
    <svg x={0} y={0} width={size} height={size}>
      <rect x={0} y={size - barHeight} width={size} height={barHeight} fill={barFill} />
    </svg>
  )
}
